import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { manageFootballTeamService } from "../../../../../../commons";
import { StatusEnum } from "../../../../../../commons/enums/status-enum";
import { TeamStatusEnum } from "../../../../../../commons/enums/team-status-enum";

interface ISubTeamTerminateState {
  subTeamTerminateStatus: StatusEnum;
}

const initialState: ISubTeamTerminateState = {
  subTeamTerminateStatus: StatusEnum.Idle,
};

export interface subTeamTerminateOption {
  teamId: number;
  subTeamId: number;
}

export const subTeamTerminate = createAsyncThunk(
  "manage/subTeamTerminate",
  async (options: subTeamTerminateOption, thunkAPI) => {
    try {
      const subTeamTerminateResponse = await manageFootballTeamService.changeSubTeamStatus(
        options.teamId,
        options.subTeamId,
        {
          status: Number(TeamStatusEnum.Terminated),
        }
      );
      return subTeamTerminateResponse;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

const subTeamTerminateSlice = createSlice({
  name: "subTeamTerminate",
  initialState: initialState,
  reducers: {
    cleanUpTeamTerminate(state) {
      state.subTeamTerminateStatus = StatusEnum.Idle;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(subTeamTerminate.pending, (state) => {
        state.subTeamTerminateStatus = StatusEnum.Loading;
      })
      .addCase(subTeamTerminate.fulfilled, (state, action) => {
        state.subTeamTerminateStatus = StatusEnum.Succeeded;
      })
      .addCase(subTeamTerminate.rejected, (state) => {
        state.subTeamTerminateStatus = StatusEnum.Failed;
      });
  },
});

export const { cleanUpTeamTerminate } = subTeamTerminateSlice.actions;
export default subTeamTerminateSlice.reducer;
